export const usersListIntroSteps = [
  {
    element: '#help-tour-btn',
    intro: 'Click here to take a tour of this page.'
  },
  {
    element: '.section-header',
    intro: 'User List is where you can add teacher and school reports users for your school.',
  },
  {
    element: '#add-button',
    intro: 'Click here to add new teachers or School Reports Users to WordFlight. A teacher can have students assigned to them and '
      + 'sees data for the selected students. School Reports Users can see data for all students at the school. Teacher School '
      + 'Reports Users have the capabilities of both a teacher and a School Reports User.',
  },
  {
    element: '#archive-button',
    intro: 'Click here to archive a teacher or school reports user.',
  },
  {
    element: '.edit-button',
    intro: 'Click here to edit a user’s name, email, or role.',
  }
];
